/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * This is a functional component used to decorate the
 * markup of all most common form fields.
 *
 * It provides the HTML wrapper for inputs, selects, and textareas.
 *
 * @vue-prop {String} uid the unique id of the control
 * @vue-prop {String} [label=] the control label
 * @vue-prop {String} [tip=] tips of the control (tooltip on the label)
 * @vue-prop {String} [hint=] hints of the control (small text below)
 * @vue-prop {String[]} [errors=] eventual control errors
 *
 * @example
 *
 * control-decorator(:uid="uid" :label="label" :tip="tip" :hint="hint" :errors="errors" :warning="warning" :dependant="dependant" :dependant="dependant")
 *      ...
 *
 * @category ui.components.form-elements
 * @exports ControlDecorator
 * @component
 */
const __vue_script__ = {
    name: 'ControlDecorator',

    props: {
        uid: {
            type: String,
            required: true
        },

        field: {
            type: String,
            default: null
        },

        label: {
            type: String,
            default: null
        },

        tip: {
            type: String,
            default: null
        },

        hint: {
            type: String,
            default: null
        },

        errors: {
            type: Array,
            default: () => []
        },

        hintAfterLabel: {
            type: Boolean,
            default: false
        },

        warning: {
            type: String,
            default: null
        },

        dependant: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        /** @returns {string|null} */
        outerTooltip() {
            if (this.label) {
                return null;
            }
            return this.tip;
        },

        hasActions() {
            const slot = this.$scopedSlots['control-actions'];
            return slot && !!slot();
        },

        hasHintSlot() {
            const slot = this.$scopedSlots['hint'];
            return slot && !!slot();
        },

        hasHint() {
            return this.hint || this.hasHintSlot;
        }
    },

    created() {
        window.S = this.$scopedSlots;
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:(_vm.outerTooltip),expression:"outerTooltip",modifiers:{"bottom":true}}],staticClass:"form-group",class:{ 'feature-dependant': _vm.dependant },attrs:{"data-testid":_vm.field},on:{"click":function (ev) { return _vm.$emit('click', ev); }}},[(_vm.hasActions)?_c('div',{staticClass:"actions"},[_vm._t("control-actions")],2):_vm._e(),(_vm.label)?_c('label',{staticClass:"control-label",attrs:{"for":_vm.uid}},[_vm._t("label-icon"),_c('span',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.label)}}),(_vm.tip)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:(_vm.tip),expression:"tip",modifiers:{"right":true}}],staticClass:"tip ic-info-fill"}):_vm._e(),_vm._t("inside-label")],2):_vm._e(),_vm._t("label"),(_vm.hasHint && _vm.hintAfterLabel)?_c('div',{staticClass:"control-hint"},[(_vm.hasHintSlot)?_vm._t("hint"):[_vm._v(_vm._s(_vm.hint))]],2):_vm._e(),_vm._t("after-label"),_vm._t("default"),(_vm.errors.length)?_c('p',{staticClass:"help error",attrs:{"data-testid":_vm.field ? (_vm.field + "-error") : null}},[_vm._v(_vm._s(_vm.errors[_vm.errors.length - 1]))]):(_vm.warning)?_c('p',{staticClass:"help warning"},[_vm._v(_vm._s(_vm.warning))]):_vm._e(),(_vm.hasHint && !_vm.hintAfterLabel)?_c('div',{staticClass:"control-hint"},[(_vm.hasHintSlot)?_vm._t("hint"):[_vm._v(_vm._s(_vm.hint))]],2):_vm._e()],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ControlDecorator.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__